import _ from 'lodash';
import angular from 'angular';
import template from './template.html';
import Logger from '../../../../../shared/logger';
import './style.scss';

export const CONFIDENTIAL_PROFILE = 'CONFIDENTIAL_PROFILE';
export const NAMED_PROFILE = 'NAMED_PROFILE';
export const FULL_PROFILE = 'FULL_PROFILE';

export class RecruiterCandidateActionPanel {
    /* @ngInject */
    constructor(
        $timeout,
        ProfileService,
        $state,
        clipboard,
        NotificationService,
        PublicProfileLinkGenerator,
        ModalDialogService,
    ) {
        this.$timeout = $timeout;
        this.ProfileService = ProfileService;
        this.$state = $state;
        this.clipboard = clipboard;
        this.NotificationService = NotificationService;
        this.PublicProfileLinkGenerator = PublicProfileLinkGenerator;
        this.ModalDialogService = ModalDialogService;
    }

    $onInit() {
        this.setDefaultValues();
    }

    setDefaultValues() {
        this.activeSideBar = 'default';
        const printIcon = {
            cssClass: 'printer-icon',
            src: 'assets/img/icons/build/svg-sprite.svg#printer',
        };
        const pdfIcon = {
            cssClass: 'render-pdf-icon',
            src: 'assets/img/icons/build/svg-sprite.svg#new_pdf',
        };
        const shareProfileIcon = {
            cssClass: 'copy-link-icon',
            src: 'assets/img/icons/build/svg-sprite.svg#copy_icon',
        };
        const baseProfileOptions = [
            {
                label: CONFIDENTIAL_PROFILE,
                value: CONFIDENTIAL_PROFILE,
                description: 'WITHOUT_CANDIDATE_NAME_N_CONTACT_DETAILS',
            },
            {
                label: NAMED_PROFILE,
                value: NAMED_PROFILE,
                description: 'WITHOUT_CANDIDATE_CONTACT_DETAILS',
            },
            {
                label: FULL_PROFILE,
                value: FULL_PROFILE,
                description: 'INCLUDE_ALL_DETAILS',
            },
        ];

        this.printProfileOptions = baseProfileOptions.map(option => Object.assign({}, option, { icon: printIcon }));
        this.pdfProfileOptions = baseProfileOptions.map(option => Object.assign({}, option, { icon: pdfIcon }));

        this.isShareProfileAvailable = this.getShareProfileAvailabilityState(this.candidate);
        if (this.isShareProfileAvailable) {
            this.shareLinkOptions = baseProfileOptions.map(option => Object.assign({}, option, { icon: shareProfileIcon }));
            this.shareLinkOptions.pop();
        }
    }

    printCandidateProfileWithOptions(option) {
        this.printCandidateProfile(option);
    }

    downloadCandidateProfileWithOptions(option) {
        this.downloadCandidateProfile(option);
    }

    getProfileType() {
        const { isProfileForSubmission } = this;

        return isProfileForSubmission ? 'talentForEmployer' : 'candidate';
    }

    printCandidateProfile({ value: mode }) {
        const {
            recruiterId,
            positionId,
            workflowStep,
            talentId,
        } = this;
        const profileType = this.getProfileType();

        return this.ProfileService.printCandidatePage({
            requesterUserType: 'recruiter',
            requesterUserId: recruiterId,
            positionId,
            workflowStep,
            talentId,
            mode,
            profileType,
        });
    }

    async downloadCandidateProfile({ value: mode }) {
        this.loading = true;

        try {
            const {
                recruiterId,
                positionId,
                workflowStep,
                candidate,
                talentId,
                pdfFileName,
            } = this;
            const candidateName = _.get(candidate, 'candidateData.name', '');
            const showName = mode !== CONFIDENTIAL_PROFILE;
            const profileType = this.getProfileType();
            const fileName = pdfFileName ? `${pdfFileName}.pdf` : undefined;

            await this.ProfileService.downloadCandidatePageAsPdf({
                requesterUserType: 'recruiter',
                requesterUserId: recruiterId,
                positionId,
                workflowStep,
                talentId,
                candidateName,
                showName,
                profileType,
                mode,
                fileName,
            });
        } catch (error) {
            Logger.error(error);
        } finally {
            this.loading = false;
        }
    }

    shareProfile(option) {
        const profileType = option.value;
        const isNamedProfile = profileType === 'NAMED_PROFILE';
        const isProfileForSubmission = this.isProfileForSubmission;
        const candidate = this.candidate;

        try {
            const publicProfileLink = this.PublicProfileLinkGenerator.generateLink(candidate, {
                isProfileForSubmission,
                isNamedProfile,
            });

            this.clipboard.copyText(publicProfileLink);
            this.NotificationService.success('PROFILE_URL_COPY');
        } catch (error) {
            Logger.error(error);
        }
    }

    showModal(onConfirm) {
        this.ModalDialogService.showDialog({
            modalDialogId: 'GdprPositionWarning',
            title: 'TE_GDPR_POSITION_WARNING_NOTIFICATION_LABEL',
            body: 'TE_GDPR_POSITION_WARNING_NOTIFICATION_TEXT',
            showCancelButton: false,
            showCloseButton: false,
            customZIndex: 2000,
            buttons: [
                {
                    label: 'OK',
                    className: 'primary-button call-for-action',
                    onClick: () => onConfirm(),
                },
            ],
        });
    }

    sideBarChange(sideBar) {
        const shouldShowGdprWarning = this.shouldDisplayGdprWarningOnPrintPdf
            && ['downloadCandidateProfile', 'printCandidateProfile'].includes(sideBar);
        if (shouldShowGdprWarning) {
            this.showModal(() => this.onSideBarChange({ sideBar }));
        } else {
            this.onSideBarChange({ sideBar });
        }
    }

    getShareProfileAvailabilityState(candidate) {
        const recruiterStatus = _.get(candidate, 'workflow.recruiterStatus.current');

        return recruiterStatus && recruiterStatus !== 'PROSPECTS';
    }
}

export const RecruiterCandidateActionPanelConfiguration = {
    template,
    controller: RecruiterCandidateActionPanel,
    bindings: {
        activeSideBar: '<',
        candidate: '<',
        isProfileForSubmission: '<',
        recruiterId: '<',
        positionId: '<',
        workflowStep: '<',
        talentId: '<',
        talentForEmployerId: '<',
        hideNoteItem: '=',
        hidePrintItem: '=',
        pdfFileName: '<',
        onSideBarChange: '&',
        shouldDisplayGdprWarningOnPrintPdf: '<',
    },
    controllerAs: 'recruiterCandidateActionPanelCtrl',
};

angular
    .module('TALENYA-FE')
    .component('recruiterCandidateActionPanel', RecruiterCandidateActionPanelConfiguration);
